import { RequestStatus } from "@/api/Requests";

const inProgress = (requestId: string) => {
  return `<svg version="1.1" id="Layer_1" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve" class="marker-requet-in-progress" data-cy="marker-request-in-progress-${requestId}">
      <style type="text/css">
      .marker-requet-in-progress .st0{fill:none;stroke:#B2B2B2;stroke-miterlimit:10;}
      .marker-requet-in-progress .st1{fill:#B2B2B2;}
      .marker-requet-in-progress .st2{fill:url(#Pin_1_);}
      .marker-requet-in-progress .st3{fill:#FFFFFF;}
      .marker-requet-in-progress .st4{opacity:0.75;}
      .marker-requet-in-progress .st5{fill:none;stroke:#28AC19;stroke-miterlimit:10;}
      .marker-requet-in-progress .st6{fill:none;stroke:#28AC19;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
      .marker-requet-in-progress .st7{fill:#28AC19;}
      .marker-requet-in-progress .st8{fill:none;stroke:#28AC19;stroke-linecap:round;stroke-miterlimit:10;}
      </style>
      <g id="Disk">
         <ellipse id="Group_2_1_" class="st0" cx="30" cy="55.5" rx="15" ry="3.75"/>
         <ellipse id="Group_1_1_" class="st1" cx="30" cy="55.5" rx="7.5" ry="1.88"/>
      </g>
      <linearGradient id="Pin_1_" gradientUnits="userSpaceOnUse" x1="30" y1="0.5" x2="30" y2="55.5">
         <stop offset="0" style="stop-color:#D9D9D9"/>
         <stop offset="1" style="stop-color:#808080"/>
      </linearGradient>
      <path id="Pin" class="st2" d="M52,22.5c0,12.15-22,33-22,33S8,34.65,8,22.5s9.85-22,22-22S52,10.35,52,22.5z"/>
      <circle class="st3" cx="30" cy="22" r="18"/>
      <g id="Highlight_1_" class="st4">
   
         <image data-cy="img-marker-request-in-progress" style="overflow:visible;" width="94" height="102" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF4AAABmCAYAAABC+yauAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABA5JREFUeNrsm3tT2kAUxTchAUQF QWtr27Hf/2P5h62P+kDeEJJupmfLZY2ddqrlbub8Zs6ECbQjZ4937+5GYwghhBBCCCGEEEIIIYQQ QgghhBBCCCGEEEIIIfUkqtOXKYqi8vtEUVTQ+LczOvrN9ykgNYMQBW54eY3FNRYD4AzOPRUazI8C NTwWalglQu5+ydoqs1pBGe7t3PwkwIQ3hNlNqG3VglK8X8DsmdXUamI1x/3c/p87LTtJIKZHIt0p DN6z6lgdWO3j2sF7DSS7NHpodS8GI8eAMPF/YLpLeAvmHlp1rfpWPagrjI9h7tjqO/5tORAL3F9j AGj8C6a7lDeR8DLVR1bHVifQAMYfoOQkSHOZ9ke8nuB1Kup/tMvUJ8pNdynfR6JLw0+t3kMnML2D wYmR5CUm0khrA5EoN72NJA9g+AerjzD9GIPRgrk5SombTJ9Q2+/weoYyk4vensZX1PQWTC9TfWb1 2eoTzO/jt6CBZLuuZQST3fXRM3+Oz+dM/PN1hetcOjC4NP2L1Tle9zEoOSbPsmt5EHLGjz1N8BuR 7Trtqoz30t5GGTlFys+R+AFq+RKG31rdQPdI+AhlZQajF/j8SqSdCygv7TGMdWk/RU0/Q01volyU Jn+z+orrLUwfw/ClaBvXon1Us2WQKEu762IOYbTrXga4v0Q5ubS6wPUa99zKdOUbrXGTLFGW9hT9 eg/Gv0Py2ygTj0j4BXSF9E/E4kit2aqM92p7E51MXyyODvDRCUrKJXSFVelYTJq5ZrM1Jl727Ycw 3K1IU1FirpH4ayR97LeI2g3XZLxfZrrYFjjCJOvSfgfDbzAIW0kPxXCZNA1lJvJWql1cE6T9CWXl tg6m79z4ilLjtnv3UO+N2Oy6h+kjTSvQkI2X++3ycMPtqbt9l6FYHK009eQhJ94/7JBHd3OzfYL0 q08P1XRNxkvz5TbuGkYvjaJDjLoZ/2zuNZujutxbiRoNG111NV6WH3mtBbHChBcV3U4KJZgDotAH IVZmem42u4nGbA5EZIvpJt/opUf2aPzfm56Z7b3z2GyeLOh45jPxr4AzXZ6ZLnDfnUa552Zo/D/P nj/7cKcMffrYbI7vFjC45SU+CX2y1VJq3NNdM5guz0+XMDiF6akwPdg6nygrNXOYXe5E9pD0Hu6v vbYy6FKzc+PLclNiNo/YjWB8B7V8ivdc6ckq2k4a/wrlZooyk8LwIT4zhOZ1MF+F8SL1stwYJPwB ZcXV/6kRT4SFulGm6fEOP/XukbwmjM/M5nmZzNu3CQ5VE1TFY9lyi8BNwLXYFlbXGXjHgf7fNOXi amj825hf9fMVoRseFCFvhhFCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgj5L/wQYABSYK7LRkmz wwAAAABJRU5ErkJggg==" transform="matrix(1 0 0 1 -26 -33)">
         </image>
      </g>
      <g>
         <circle class="st5" cx="30" cy="22" r="14"/>
         <polyline class="st6" points="39.19,13.69 30,22 25.19,17.19 	"/>
         <path class="st7" d="M40.9,19.06l3.19,2.23l2.23-3.19c0.22-0.32-0.05-0.75-0.43-0.68l-4.81,0.85
         C40.69,18.34,40.58,18.84,40.9,19.06z"/>
         <path class="st7" d="M19.1,24.94l-3.19-2.23l-2.23,3.19c-0.22,0.32,0.05,0.75,0.43,0.68l4.81-0.85
         C19.31,25.66,19.42,25.16,19.1,24.94z"/>
         <g>
            <line class="st8" x1="30" y1="9.75" x2="30" y2="11.5"/>
            <line class="st8" x1="30" y1="32.5" x2="30" y2="34.25"/>
            <line class="st8" x1="23.88" y1="11.39" x2="24.75" y2="12.91"/>
            <line class="st8" x1="35.25" y1="31.09" x2="36.12" y2="32.61"/>
            <line class="st8" x1="19.39" y1="15.87" x2="20.91" y2="16.75"/>
            <line class="st8" x1="39.09" y1="27.25" x2="40.61" y2="28.13"/>
            <line class="st8" x1="17.75" y1="22" x2="19.5" y2="22"/>
            <line class="st8" x1="40.5" y1="22" x2="42.25" y2="22"/>
            <line class="st8" x1="19.39" y1="28.12" x2="20.91" y2="27.25"/>
            <line class="st8" x1="39.09" y1="16.75" x2="40.61" y2="15.88"/>
            <line class="st8" x1="23.87" y1="32.61" x2="24.75" y2="31.09"/>
            <line class="st8" x1="35.25" y1="12.91" x2="36.13" y2="11.39"/>
         </g>
      </g>
   </svg>
   `;
};

const inProgressWithErrors = (errorCount: number, requestId: string) => {
  return `<svg version="1.1" id="Layer_1" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve" class="marker-request-in-progress-with-error" data-cy="marker-request-in-progress-with-error-${requestId}">
      <style type="text/css" id="style2">
      .marker-request-in-progress-with-error .st0{fill:none;stroke:#B2B2B2;stroke-miterlimit:10;}
      .marker-request-in-progress-with-error .st1{fill:#B2B2B2;}
      .marker-request-in-progress-with-error .st2{fill:url(#Pin_1_);}
      .marker-request-in-progress-with-error .st3{fill:#FFFFFF;}
      .marker-request-in-progress-with-error .st4{opacity:0.75;}
      .marker-request-in-progress-with-error .st5{fill:none;stroke:#FFD400;stroke-miterlimit:10;}
      .marker-request-in-progress-with-error .st6{fill:none;stroke:#FFD400;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
      .marker-request-in-progress-with-error .st7{fill:#FFD400;}
      .marker-request-in-progress-with-error .st8{fill:none;stroke:#FFD400;stroke-linecap:round;stroke-miterlimit:10;}
      .marker-request-in-progress-with-error .st9{fill:#B21212;}
      .marker-request-in-progress-with-error .st10{font-family:Roboto;}
      .marker-request-in-progress-with-error .st11{font-size:9.25px;}
      </style>
      <g id="Disk">
         <ellipse id="Group_2_1_" class="st0" cx="30" cy="55.5" rx="15" ry="3.8" />
         <ellipse id="Group_1_1_" class="st1" cx="30" cy="55.5" rx="7.5" ry="1.9" />
      </g>
      <linearGradient id="Pin_1_" gradientUnits="userSpaceOnUse" x1="30" y1="1018.5" x2="30" y2="1073.5" gradientTransform="matrix(1 0 0 1 0 -1018)">
         <stop offset="0" style="stop-color:#D9D9D9" id="stop7" />
         <stop offset="1" style="stop-color:#808080" id="stop9" />
      </linearGradient>
      <path id="Pin" class="st2" d="M52,22.5c0,12.2-22,33-22,33S8,34.7,8,22.5s9.9-22,22-22S52,10.4,52,22.5z" />
      <circle class="st3" cx="30" cy="22" r="18" id="circle13" />
   
      <g id="g52">
         <circle class="st5" cx="30" cy="22" r="14" id="circle18" />
         <polyline class="st6" points="39.2,13.7 30,22 25.2,17.2  " id="polyline20" />
         <path class="st7" d="M40.9,19.1l3.2,2.2l2.2-3.2c0.2-0.3,0-0.8-0.4-0.7l-4.8,0.9C40.7,18.3,40.6,18.8,40.9,19.1z" id="path22" />
         <path class="st7" d="M19.1,24.9l-3.2-2.2l-2.2,3.2c-0.2,0.3,0.1,0.8,0.4,0.7l4.8-0.9C19.3,25.7,19.4,25.2,19.1,24.9z" id="path24" />
         <g id="g50">
            <line class="st8" x1="30" y1="9.8" x2="30" y2="11.5" id="line26" />
            <line class="st8" x1="30" y1="32.5" x2="30" y2="34.2" id="line28" />
            <line class="st8" x1="23.9" y1="11.4" x2="24.8" y2="12.9" id="line30" />
            <line class="st8" x1="35.2" y1="31.1" x2="36.1" y2="32.6" id="line32" />
            <line class="st8" x1="19.4" y1="15.9" x2="20.9" y2="16.8" id="line34" />
            <line class="st8" x1="39.1" y1="27.2" x2="40.6" y2="28.1" id="line36" />
            <line class="st8" x1="17.8" y1="22" x2="19.5" y2="22" id="line38" />
            <line class="st8" x1="40.5" y1="22" x2="42.2" y2="22" id="line40" />
            <line class="st8" x1="19.4" y1="28.1" x2="20.9" y2="27.2" id="line42" />
            <line class="st8" x1="39.1" y1="16.8" x2="40.6" y2="15.9" id="line44" />
            <line class="st8" x1="23.9" y1="32.6" x2="24.8" y2="31.1" id="line46" />
            <line class="st8" x1="35.2" y1="12.9" x2="36.1" y2="11.4" id="line48" />
         </g>
      </g>
      <circle class="st9" cx="12" cy="9" r="6" id="circle54" />
      <text class="st3 st10 st11" id="text56" x="9.4282999" y="11.7393" style="font-size:9.25px;font-family:HelveticaNeue-Bold;fill:#ffffff">${errorCount}</text>
   </svg>
 `;
};

const inProgressAssigned = (requestId: string) => {
  return `<svg version="1.1" id="Layer_1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60"
       style="enable-background:new 0 0 60 60;" xml:space="preserve"
       class="marker-request-in-progress-assigned" data-cy="marker-request-in-progress-assigned-${requestId}">
   <style type="text/css">
      .marker-request-in-progress-assigned .st0{fill:none;stroke:#B2B2B2;stroke-miterlimit:10;}
      .marker-request-in-progress-assigned .st1{fill:#B2B2B2;}
      .marker-request-in-progress-assigned .st2{fill:url(#Pin_1_);}
      .marker-request-in-progress-assigned .st3{fill:#FFFFFF;}
      .marker-request-in-progress-assigned .st4{fill:#E61D2D;}
      .marker-request-in-progress-assigned .st5{fill:none;stroke:#2EAD4A;stroke-miterlimit:10;}
      .marker-request-in-progress-assigned .st6{fill:none;stroke:#2EAD4A;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
      .marker-request-in-progress-assigned .st7{fill:#2EAD4A;}
      .marker-request-in-progress-assigned .st8{fill:none;stroke:#2EAD4A;stroke-linecap:round;stroke-miterlimit:10;}
   </style>
   <switch>     
      <g>
         <g id="Disk">
            <ellipse id="Group_2_1_" class="st0" cx="30" cy="55.5" rx="15" ry="3.8"/>
            <ellipse id="Group_1_1_" class="st1" cx="30" cy="55.5" rx="7.5" ry="1.9"/>
         </g>
         
            <linearGradient id="Pin_1_" gradientUnits="userSpaceOnUse" x1="30" y1="782.5" x2="30" y2="837.5" gradientTransform="matrix(1 0 0 1 0 -782)">
            <stop  offset="0" style="stop-color:#D8D8D7"/>
            <stop  offset="1" style="stop-color:#808080"/>
         </linearGradient>
         <path id="Pin" class="st2" d="M52,22.5c0,12.2-22,33-22,33S8,34.7,8,22.5s9.9-22,22-22S52,10.4,52,22.5z"/>
         <circle class="st3" cx="30" cy="22" r="18"/>
         <g>
            <circle class="st4" cx="52" cy="8" r="8"/>
         </g>
         <g>
            <path class="st3" d="M47.9,5.8c0-0.4,0.2-0.9,1.3-0.9h5.6c0.6,0,1.3,0.3,1.3,1l0,1.6h0.2V2.8c0-0.3-0.2-0.5-0.5-0.5h-7.8
               c-0.3,0-0.5,0.2-0.5,0.5v4.6h0.2L47.9,5.8z"/>
            <path class="st3" d="M56.6,7.8h-0.8l-0.1-1.9c0-0.4-0.6-0.6-1-0.6h-5.6c-0.4,0-0.9,0.1-1,0.6l-0.1,1.9h-0.8
               c-0.2,0-0.2,0.4-0.2,0.6c0,0.2,0.1,0.3,0.2,0.4L47.8,9c0,0.1-0.1,0.1-0.1,0.4v3.4c0,0.1,0.1,0.2,0.2,0.2H48v0.5
               c0,0.1,0.1,0.2,0.2,0.2h0.9c0.1,0,0.2-0.1,0.2-0.2v-0.5h5.4v0.5c0,0.1,0.1,0.2,0.2,0.2h0.9c0.1,0,0.2-0.1,0.2-0.2v-0.5h0.1
               c0.1,0,0.2-0.1,0.2-0.2V9.4c0-0.3-0.1-0.4-0.1-0.4l0.4-0.2c0.1-0.1,0.2-0.2,0.2-0.4C56.8,8.2,56.8,7.8,56.6,7.8z M49.3,5.7h5.6
               c0.3,0,0.6,0.1,0.6,0.5l0.1,2c0,0.2-0.2,0.5-0.5,0.5l-5.8,0c0,0,0,0,0,0c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.1-0.2-0.1-0.3l0.1-2
               C48.7,5.9,48.8,5.7,49.3,5.7z M49.9,11.7c0,0.1-0.1,0.2-0.2,0.2h-1.2c-0.1,0-0.2-0.1-0.2-0.2v-0.4c0-0.1,0.1-0.2,0.2-0.2l1.2,0.1
               c0.1,0,0.2,0.1,0.2,0.2V11.7z M53.7,12c0,0.1-0.1,0.2-0.3,0.2h-2.8c-0.2,0-0.3-0.1-0.3-0.2v-1.6c0-0.1,0.1-0.2,0.3-0.2h2.8
               c0.2,0,0.3,0.1,0.3,0.2V12z M55.8,11.7c0,0.1-0.1,0.2-0.2,0.2h-1.2c-0.1,0-0.2-0.1-0.2-0.2v-0.4c0-0.1,0.1-0.2,0.2-0.2l1.2-0.1
               c0.1,0,0.2,0.1,0.2,0.2V11.7z"/>
         </g>
         <g>
            <circle class="st5" cx="30" cy="22" r="14"/>
            <polyline class="st6" points="39.2,13.7 30,22 25.2,17.2 			"/>
            <path class="st7" d="M40.9,19.1l3.2,2.2l2.2-3.2c0.2-0.3,0-0.8-0.4-0.7l-4.8,0.9C40.7,18.3,40.6,18.8,40.9,19.1z"/>
            <path class="st7" d="M19.1,24.9l-3.2-2.2l-2.2,3.2c-0.2,0.3,0.1,0.8,0.4,0.7l4.8-0.9C19.3,25.7,19.4,25.2,19.1,24.9z"/>
            <g>
               <line class="st8" x1="30" y1="9.8" x2="30" y2="11.5"/>
               <line class="st8" x1="30" y1="32.5" x2="30" y2="34.2"/>
               <line class="st8" x1="23.9" y1="11.4" x2="24.8" y2="12.9"/>
               <line class="st8" x1="35.2" y1="31.1" x2="36.1" y2="32.6"/>
               <line class="st8" x1="19.4" y1="15.9" x2="20.9" y2="16.8"/>
               <line class="st8" x1="39.1" y1="27.2" x2="40.6" y2="28.1"/>
               <line class="st8" x1="17.8" y1="22" x2="19.5" y2="22"/>
               <line class="st8" x1="40.5" y1="22" x2="42.2" y2="22"/>
               <line class="st8" x1="19.4" y1="28.1" x2="20.9" y2="27.2"/>
               <line class="st8" x1="39.1" y1="16.8" x2="40.6" y2="15.9"/>
               <line class="st8" x1="23.9" y1="32.6" x2="24.8" y2="31.1"/>
               <line class="st8" x1="35.2" y1="12.9" x2="36.1" y2="11.4"/>
            </g>
         </g>
      </g>
   </switch>
   </svg>
   `;
};

const complete = (requestId: string) => {
  return `<svg version="1.1" id="Layer_1" 
     xmlns="http://www.w3.org/2000/svg" 
     xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve" class="marker-request-complete" data-cy="marker-request-complete-${requestId}">
     <style type="text/css">
     .marker-request-complete .st0{fill:none;stroke:#B2B2B2;stroke-miterlimit:10;}
     .marker-request-complete .st1{fill:#B2B2B2;}
     .marker-request-complete .st2{fill:url(#Pin_1_);}
     .marker-request-complete .st3{fill:#FFFFFF;}
     .marker-request-complete .st4{opacity:0.75;}
     .marker-request-complete .st5{fill:#28AC19;}
     </style>
     <g id="Disk">
        <ellipse id="Group_2_2_" class="st0" cx="30" cy="55.5" rx="15" ry="3.75"/>
        <ellipse id="Group_1_4_" class="st1" cx="30" cy="55.5" rx="7.5" ry="1.88"/>
     </g>
     <linearGradient id="Pin_1_" gradientUnits="userSpaceOnUse" x1="30" y1="0.5" x2="30" y2="55.5">
        <stop offset="0" style="stop-color:#D9D9D9"/>
        <stop offset="1" style="stop-color:#808080"/>
     </linearGradient>
     <path id="Pin" class="st2" d="M52,22.5c0,12.15-22,33-22,33S8,34.65,8,22.5s9.85-22,22-22S52,10.35,52,22.5z"/>
     <circle class="st3" cx="30" cy="22" r="18"/>
     <g id="Highlight" class="st4">
  
        <image data-cy="img-request-complete" style="overflow:visible;" width="94" height="102" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF4AAABmCAYAAABC+yauAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABA5JREFUeNrsm3tT2kAUxTchAUQF QWtr27Hf/2P5h62P+kDeEJJupmfLZY2ddqrlbub8Zs6ECbQjZ4937+5GYwghhBBCCCGEEEIIIYQQ QgghhBBCCCGEEEIIIfUkqtOXKYqi8vtEUVTQ+LczOvrN9ykgNYMQBW54eY3FNRYD4AzOPRUazI8C NTwWalglQu5+ydoqs1pBGe7t3PwkwIQ3hNlNqG3VglK8X8DsmdXUamI1x/3c/p87LTtJIKZHIt0p DN6z6lgdWO3j2sF7DSS7NHpodS8GI8eAMPF/YLpLeAvmHlp1rfpWPagrjI9h7tjqO/5tORAL3F9j AGj8C6a7lDeR8DLVR1bHVifQAMYfoOQkSHOZ9ke8nuB1Kup/tMvUJ8pNdynfR6JLw0+t3kMnML2D wYmR5CUm0khrA5EoN72NJA9g+AerjzD9GIPRgrk5SombTJ9Q2+/weoYyk4vensZX1PQWTC9TfWb1 2eoTzO/jt6CBZLuuZQST3fXRM3+Oz+dM/PN1hetcOjC4NP2L1Tle9zEoOSbPsmt5EHLGjz1N8BuR 7Trtqoz30t5GGTlFys+R+AFq+RKG31rdQPdI+AhlZQajF/j8SqSdCygv7TGMdWk/RU0/Q01volyU Jn+z+orrLUwfw/ClaBvXon1Us2WQKEu762IOYbTrXga4v0Q5ubS6wPUa99zKdOUbrXGTLFGW9hT9 eg/Gv0Py2ygTj0j4BXSF9E/E4kit2aqM92p7E51MXyyODvDRCUrKJXSFVelYTJq5ZrM1Jl727Ycw 3K1IU1FirpH4ayR97LeI2g3XZLxfZrrYFjjCJOvSfgfDbzAIW0kPxXCZNA1lJvJWql1cE6T9CWXl tg6m79z4ilLjtnv3UO+N2Oy6h+kjTSvQkI2X++3ycMPtqbt9l6FYHK009eQhJ94/7JBHd3OzfYL0 q08P1XRNxkvz5TbuGkYvjaJDjLoZ/2zuNZujutxbiRoNG111NV6WH3mtBbHChBcV3U4KJZgDotAH IVZmem42u4nGbA5EZIvpJt/opUf2aPzfm56Z7b3z2GyeLOh45jPxr4AzXZ6ZLnDfnUa552Zo/D/P nj/7cKcMffrYbI7vFjC45SU+CX2y1VJq3NNdM5guz0+XMDiF6akwPdg6nygrNXOYXe5E9pD0Hu6v vbYy6FKzc+PLclNiNo/YjWB8B7V8ivdc6ckq2k4a/wrlZooyk8LwIT4zhOZ1MF+F8SL1stwYJPwB ZcXV/6kRT4SFulGm6fEOP/XukbwmjM/M5nmZzNu3CQ5VE1TFY9lyi8BNwLXYFlbXGXjHgf7fNOXi amj825hf9fMVoRseFCFvhhFCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgj5L/wQYABSYK7LRkmz wwAAAABJRU5ErkJggg==" transform="matrix(1 0 0 1 -26 -33)">
        </image>
     </g>
     <g>
        <path class="st5" d="M17.21,28.31l8.86,9.86c0.4,0.45,1.11,0.44,1.5-0.01l18.41-21.25c0.33-0.39,0.32-0.96-0.02-1.33l-2.74-2.96
        c-0.42-0.45-1.14-0.42-1.52,0.06L26.9,31.47c-0.2,0.26-0.6,0.25-0.79-0.01l-5-6.73c-0.36-0.49-1.07-0.54-1.51-0.12l-2.35,2.33
        C16.87,27.31,16.86,27.92,17.21,28.31z"/>
     </g>
  </svg>
  
`;
};

const completeWithErrors = (errorCount: number, requestId: string) => {
  return `<svg version="1.1" id="Layer_1" 
	xmlns="http://www.w3.org/2000/svg" 
	xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve" class="marker-request-complete-with-error" data-cy="marker-request-complete-with-error-${requestId}">
	<style type="text/css">
	.marker-request-complete-with-error .st0{fill:none;stroke:#B2B2B2;stroke-miterlimit:10;}
	.marker-request-complete-with-error .st1{fill:#B2B2B2;}
	.marker-request-complete-with-error .st2{fill:url(#Pin_1_);}
	.marker-request-complete-with-error .st3{fill:#FFFFFF;}
	.marker-request-complete-with-error .st4{opacity:0.75;}
	.marker-request-complete-with-error .st5{fill:#FF8C1A;}
	.marker-request-complete-with-error .st6{fill:#B21212;}
	.marker-request-complete-with-error .st7{font-family:Roboto;}
	.marker-request-complete-with-error .st8{font-size:9.25px;}
	</style>
	<g id="Disk">
		<ellipse id="Group_2_2_" class="st0" cx="30" cy="55.5" rx="15" ry="3.75"/>
		<ellipse id="Group_1_4_" class="st1" cx="30" cy="55.5" rx="7.5" ry="1.88"/>
	</g>
	<linearGradient id="Pin_1_" gradientUnits="userSpaceOnUse" x1="30" y1="0.5" x2="30" y2="55.5">
		<stop offset="0" style="stop-color:#D9D9D9"/>
		<stop offset="1" style="stop-color:#808080"/>
	</linearGradient>
	<path id="Pin" class="st2" d="M52,22.5c0,12.15-22,33-22,33S8,34.65,8,22.5s9.85-22,22-22S52,10.35,52,22.5z"/>
	<circle class="st3" cx="30" cy="22" r="18"/>
	<g id="Highlight" class="st4">

		<image data-cy="img-request-complete-with-error" style="overflow:visible;" width="94" height="102" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF4AAABmCAYAAABC+yauAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABA5JREFUeNrsm3tT2kAUxTchAUQF QWtr27Hf/2P5h62P+kDeEJJupmfLZY2ddqrlbub8Zs6ECbQjZ4937+5GYwghhBBCCCGEEEIIIYQQ QgghhBBCCCGEEEIIIfUkqtOXKYqi8vtEUVTQ+LczOvrN9ykgNYMQBW54eY3FNRYD4AzOPRUazI8C NTwWalglQu5+ydoqs1pBGe7t3PwkwIQ3hNlNqG3VglK8X8DsmdXUamI1x/3c/p87LTtJIKZHIt0p DN6z6lgdWO3j2sF7DSS7NHpodS8GI8eAMPF/YLpLeAvmHlp1rfpWPagrjI9h7tjqO/5tORAL3F9j AGj8C6a7lDeR8DLVR1bHVifQAMYfoOQkSHOZ9ke8nuB1Kup/tMvUJ8pNdynfR6JLw0+t3kMnML2D wYmR5CUm0khrA5EoN72NJA9g+AerjzD9GIPRgrk5SombTJ9Q2+/weoYyk4vensZX1PQWTC9TfWb1 2eoTzO/jt6CBZLuuZQST3fXRM3+Oz+dM/PN1hetcOjC4NP2L1Tle9zEoOSbPsmt5EHLGjz1N8BuR 7Trtqoz30t5GGTlFys+R+AFq+RKG31rdQPdI+AhlZQajF/j8SqSdCygv7TGMdWk/RU0/Q01volyU Jn+z+orrLUwfw/ClaBvXon1Us2WQKEu762IOYbTrXga4v0Q5ubS6wPUa99zKdOUbrXGTLFGW9hT9 eg/Gv0Py2ygTj0j4BXSF9E/E4kit2aqM92p7E51MXyyODvDRCUrKJXSFVelYTJq5ZrM1Jl727Ycw 3K1IU1FirpH4ayR97LeI2g3XZLxfZrrYFjjCJOvSfgfDbzAIW0kPxXCZNA1lJvJWql1cE6T9CWXl tg6m79z4ilLjtnv3UO+N2Oy6h+kjTSvQkI2X++3ycMPtqbt9l6FYHK009eQhJ94/7JBHd3OzfYL0 q08P1XRNxkvz5TbuGkYvjaJDjLoZ/2zuNZujutxbiRoNG111NV6WH3mtBbHChBcV3U4KJZgDotAH IVZmem42u4nGbA5EZIvpJt/opUf2aPzfm56Z7b3z2GyeLOh45jPxr4AzXZ6ZLnDfnUa552Zo/D/P nj/7cKcMffrYbI7vFjC45SU+CX2y1VJq3NNdM5guz0+XMDiF6akwPdg6nygrNXOYXe5E9pD0Hu6v vbYy6FKzc+PLclNiNo/YjWB8B7V8ivdc6ckq2k4a/wrlZooyk8LwIT4zhOZ1MF+F8SL1stwYJPwB ZcXV/6kRT4SFulGm6fEOP/XukbwmjM/M5nmZzNu3CQ5VE1TFY9lyi8BNwLXYFlbXGXjHgf7fNOXi amj825hf9fMVoRseFCFvhhFCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgj5L/wQYABSYK7LRkmz wwAAAABJRU5ErkJggg==" transform="matrix(1 0 0 1 -26 -33)">
		</image>
	</g>
	<g>
		<path class="st5" d="M17.21,28.31l8.86,9.86c0.4,0.45,1.11,0.44,1.5-0.01l18.41-21.25c0.33-0.39,0.32-0.96-0.02-1.33l-2.74-2.96
		c-0.42-0.45-1.14-0.42-1.52,0.06L26.9,31.47c-0.2,0.26-0.6,0.25-0.79-0.01l-5-6.73c-0.36-0.49-1.07-0.54-1.51-0.12l-2.35,2.33
		C16.87,27.31,16.86,27.92,17.21,28.31z"/>
	</g>
	<circle class="st6" cx="12" cy="9" r="6"/>
	<text transform="matrix(1 0 0 1 9.4287 11.7391)" class="st3 st7 st8">${errorCount}</text>
</svg>

    `;
};

export const requestMarker = (status: RequestStatus, errorCount: number, requestId: string) => {
  switch (status) {
    case RequestStatus.InProgress:
      return inProgress(requestId);
    case RequestStatus.InProgressAssigned:
      return inProgressAssigned(requestId);
    case RequestStatus.InProgressWithErrors:
      return inProgressWithErrors(errorCount, requestId);
    case RequestStatus.Complete:
      return complete(requestId);
    case RequestStatus.CompleteWithErrors:
      return completeWithErrors(errorCount, requestId);
  }
};
